import React from "react";
import {Card} from "react-bootstrap";
import {IntlMessage, IntlMessageValue, UniButton, UniCol, UniRow, UniSpinner} from "../../../../@WUM/core/Elements";
import {ResponseHolidayDashboard, ResponseNotificationSettings} from "../../API/response/settingstimetracking";
import {useSelector} from "react-redux";
import Table from "react-bootstrap/Table";
import {useNavigate} from "react-router-dom";

interface HolidayDashboardWidgetProps {
}

const HolidayDashboardWidget = (props: HolidayDashboardWidgetProps) => {
    const Store = useSelector((state: any) => state)

    const ResponseHoliday = ResponseHolidayDashboard(Store.user.id)
    //const ResponseHoliday = ResponseHolidayDashboard("3")

    const navigate = useNavigate();


    if (!ResponseHoliday || typeof ResponseHoliday === "undefined" || typeof ResponseHoliday === "boolean") return <>
        <UniSpinner/></>;

    const Year = new Date().getFullYear()

    /**
     * Returns the localized day/day pluralization using IntlMessage.
     */
    const getDayLabel = (value: number) => {
        return IntlMessage({
            locale: 'de',
            messageId: value === 1 ? 'common.day' : 'common.days',
            Store: Store
        });
    };

    const getNextDate = (value: string) => {

        if (!value || value === "undefined") {
            return <div>Keiner geplant</div>;
        }

        const date = new Date(value);

        const formattedDate = new Intl.DateTimeFormat("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }).format(date);

        return (
            <>
                {formattedDate}
            </>
        )
    }

    const hasNoVacationLeft = ResponseHoliday.freeVacationDays <= 0;

    const circleClassName = hasNoVacationLeft
        ? "d-inline-flex rounded-circle border border-2 border-danger flex-column align-items-center justify-content-center text-danger fw-bold ms-auto"
        : "d-inline-flex rounded-circle border border-2 border-success flex-column align-items-center justify-content-center text-success fw-bold ms-auto";


    return (
        <>
            <UniCol md={4} xs={6}>
                <Card className="w-100 card">
                    <Card.Header>
                        {IntlMessage({
                            locale: 'de',
                            messageId: 'time.dashboard.vacation.headline',
                            Store: Store
                        })}
                    </Card.Header>
                    <Card.Body>
                        <Table className="table-borderless mt-1">
                            <tbody>
                                <tr >
                                    <td>
                                        <div className={"fw-bold"}>{Store.user.username}</div>
                                        <div className={"text-muted"}>
                                            {IntlMessage({
                                                locale: 'de',
                                                messageId: 'time.dashboard.personal.number',
                                                Store: Store
                                            })}: {ResponseHoliday.employeeNumber}
                                        </div>
                                        <div>
                                            <UniButton variant={"outline-primary"} class={"btn-sm mt-2"} onClick={e => navigate("/member/Detail/"+ Store.user.id)} children={IntlMessageValue(
                                                'de',
                                                "time.dashboard.vacation.edit.core.data",
                                                Store
                                            )}  />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-end">
                                            <div
                                                className={circleClassName}
                                                style={{width: "75px", height: "75px"}}
                                            >
                                                <div className="fs-5">{ResponseHoliday.freeVacationDays}</div>
                                                <div className="small">
                                                    {IntlMessage({
                                                        locale: 'de',
                                                        messageId: 'time.dashboard.vacation.open',
                                                        Store: Store
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr className={"fw-bold border-top border-bottom"}>
                                    <td>
                                        {IntlMessage({
                                            locale: 'de',
                                            messageId: 'time.dashboard.vacation',
                                            Store: ''
                                        })} {Year}
                                    </td>
                                    <td className={"text-end"} >
                                        {ResponseHoliday.maxVacationDays} {getDayLabel(ResponseHoliday.maxVacationDays)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {IntlMessage({
                                            locale: 'de',
                                            messageId: 'time.dashboard.vacation.entered',
                                            Store: Store
                                        })}
                                    </td>
                                    <td className={"text-end"} >
                                        {ResponseHoliday.maxVacationDays - ResponseHoliday.freeVacationDays} {getDayLabel(ResponseHoliday.maxVacationDays - ResponseHoliday.freeVacationDays)}
                                    </td>
                                </tr>
                                <tr className={""}>
                                    <td>
                                        {IntlMessage({
                                            locale: 'de',
                                            messageId: 'time.dashboard.vacation.used',
                                            Store: Store
                                        })}
                                    </td>
                                    <td className={"text-end"} >
                                        {ResponseHoliday.CountUsedVacationsDays} {getDayLabel(ResponseHoliday.CountUsedVacationsDays)}
                                    </td>
                                </tr>
                                <tr className={"fw-bold border-top border-bottom"}>
                                    <td>
                                        {IntlMessage({
                                            locale: 'de',
                                            messageId: 'time.dashboard.vacation.rest',
                                            Store: Store
                                        })}
                                    </td>
                                    <td className={"text-end"} >
                                        {ResponseHoliday.freeVacationDays} {getDayLabel(ResponseHoliday.freeVacationDays)}
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        {IntlMessage({
                                            locale: 'de',
                                            messageId: 'time.dashboard.vacation.next',
                                            Store: Store
                                        })}
                                    </td>
                                    <td className={"text-end"} >
                                        {getNextDate(ResponseHoliday.NextVacationsDays)}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>

                    </Card.Body>
                </Card>
            </UniCol>
        </>
    );
};

export default HolidayDashboardWidget;
